<template>
  <div class="home-search-wrapper">

    <!-- PC搜索区域 -->
    <div v-if="deviceType !== 'mobile'" class="home-hero__search" @click.stop>
      <!-- 标题区域 -->
      <div class="home-hero__title-container">
        <div class="home-hero__title-bg">
          <div class="home-hero__title">Find Your Perfect Car</div>
        </div>
        <div class="home-hero__title-line"></div>
      </div>

      <!-- 筛选器 -->
      <div class="home-hero__filters">
        <!-- 类型选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('type')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Model.svg" class="home-hero__filter-icon" alt="model icon">
            <div class="home-hero__filter-text">{{ selectedType.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'type'}"
            alt="dropdown arrow">

          <!-- 类型选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'type'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in types" :key="`type-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedType.id === item.id}"
                @click.stop="selectItem('type', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 价格选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('price')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Budget.svg" class="home-hero__filter-icon"
              alt="budget icon">
            <div class="home-hero__filter-text">{{ selectedPrice.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'price'}"
            alt="dropdown arrow">

          <!-- 价格选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'price'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in prices" :key="`price-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedPrice.id === item.id}"
                @click.stop="selectItem('price', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 品牌选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('brand')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Brand.svg" class="home-hero__filter-icon" alt="brand icon">
            <div class="home-hero__filter-text">{{ selectedBrand.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'brand'}"
            alt="dropdown arrow">

          <!-- 品牌选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'brand'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in brands" :key="`brand-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedBrand.id === item.id}"
                @click.stop="selectItem('brand', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 搜索按钮 -->
      <a class="home-hero__search-btn" :href="searchHref">
        <img src="@/assets/search.svg" class="home-hero__search-icon" alt="search icon">
        <div class="home-hero__search-text">Search</div>
      </a>
    </div>

    <!-- 移动端搜索区域 -->
    <div v-if="deviceType === 'mobile'" class="home-hero__search-mobile" @click.stop>
      <!-- 标题区域 -->
      <div class="home-hero__title-container-mobile">
        <div class="home-hero__title-bg-mobile">
          <div class="home-hero__title-mobile">Find Your Perfect Car</div>
        </div>
        <div class="home-hero__title-line-mobile"></div>
      </div>

      <!-- 筛选器 -->
      <div class="home-hero__filters-mobile">
        <!-- 类型选择下拉框 -->
        <div class="home-hero__filter-mobile" @click.stop="toggleDropdown('type')">
          <div class="home-hero__filter-content-mobile">
            <img src="@/assets/homehero/Model.svg" class="home-hero__filter-icon-mobile"
              alt="model icon">
            <div class="home-hero__filter-text-mobile">{{ selectedType.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow-mobile"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'type'}"
            alt="dropdown arrow">

          <!-- 类型选择下拉菜单 -->
          <div class="home-hero__dropdown-mobile" v-show="activeDropdown === 'type'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in types" :key="`type-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedType.id === item.id}"
                @click.stop="selectItem('type', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 价格选择下拉框 -->
        <div class="home-hero__filter-mobile" @click.stop="toggleDropdown('price')">
          <div class="home-hero__filter-content-mobile">
            <img src="@/assets/homehero/Budget.svg" class="home-hero__filter-icon-mobile"
              alt="budget icon">
            <div class="home-hero__filter-text-mobile">{{ selectedPrice.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow-mobile"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'price'}"
            alt="dropdown arrow">

          <!-- 价格选择下拉菜单 -->
          <div class="home-hero__dropdown-mobile" v-show="activeDropdown === 'price'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in prices" :key="`price-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedPrice.id === item.id}"
                @click.stop="selectItem('price', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 品牌选择下拉框 -->
        <div class="home-hero__filter-mobile" @click.stop="toggleDropdown('brand')">
          <div class="home-hero__filter-content-mobile">
            <img src="@/assets/homehero/Brand.svg" class="home-hero__filter-icon-mobile"
              alt="brand icon">
            <div class="home-hero__filter-text-mobile">{{ selectedBrand.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow-mobile"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'brand'}"
            alt="dropdown arrow">

          <!-- 品牌选择下拉菜单 -->
          <div class="home-hero__dropdown-mobile" v-show="activeDropdown === 'brand'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in brands" :key="`brand-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedBrand.id === item.id}"
                @click.stop="selectItem('brand', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 搜索按钮 -->
      <a class="home-hero__search-btn-mobile" :href="searchHref">
        <img src="@/assets/search.svg" class="home-hero__search-icon-mobile" alt="search icon">
        <div class="home-hero__search-text-mobile">Search</div>
      </a>
      <AdComponent v-if="deviceType === 'mobile' && !domainConfig?.adPlacement?.mobileHomeOrder"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_2" ref="ads-home-2"
        class="ad-width-100" data-ad-placement="home_2" data-ad-source-placement="home_2" :ads="adsensConfig?.home_2" :showDebug="showDebug" />
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'

export default {
  name: 'HomeSearch',
  components: {
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      cars: [],
      currentIndex: 0,
      autoplayTimer: null,
      loading: false,
      error: null,
      autoplayInterval: 5000,

      // CarSearch 功能数据
      activeDropdown: null, // 当前展开的下拉菜单

      // 车型类型数据
      types: [
        { id: 'all-types', name: 'All Types' },
        { id: 'Sedan', name: 'Sedan' },
        { id: 'SUV', name: 'SUV' },
        { id: 'Coupe', name: 'Coupe' },
        { id: 'Hatchback', name: 'Hatchback' },
        { id: 'Wagon', name: 'Wagon' },
        { id: 'Pickup Truck', name: 'Pickup Truck' },
        { id: 'Van', name: 'Van' },
        { id: 'Convertible', name: 'Convertible' }
      ],
      selectedType: { id: 'all-types', name: 'All Types' },

      // 价格范围数据
      prices: [
        { id: 'all-prices', name: 'All Ex-Showroom Price' },
        { id: 'less_20000', name: 'Less than $20,000' },
        { id: '20001_40000', name: '$20,001 - $40,000' },
        { id: '40001_60000', name: '$40,001 - $60,000' },
        { id: '60001_80000', name: '$60,001 - $80,000' },
        { id: 'more_80001', name: 'More than $80,000' }
      ],
      selectedPrice: { id: 'all-prices', name: 'All Ex-Showroom Price' },

      // 品牌数据
      brands: [
        { id: 'all-brands', name: 'All Brands' },
        { id: 'Acura', name: 'Acura' },
        { id: 'Alfa Romeo', name: 'Alfa Romeo' },
        { id: 'Aston Martin', name: 'Aston Martin' },
        { id: 'Audi', name: 'Audi' },
        { id: 'Bentley', name: 'Bentley' },
        { id: 'BMW', name: 'BMW' },
        { id: 'Buick', name: 'Buick' },
        { id: 'Cadillac', name: 'Cadillac' },
        { id: 'Chevrolet', name: 'Chevrolet' },
        { id: 'Chrysler', name: 'Chrysler' },
      ],
      selectedBrand: { id: 'all-brands', name: 'All Brands' }
    };
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      adsensConfig: 'adsensConfig',
      showDebug: 'showDebug',
      originalTopCars: 'originalTopCars',
      topCarsLoaded: 'topCarsLoaded',
      topCarsLoadTime: 'topCarsLoadTime',
      domainConfig: 'domainConfig'
    }),
    searchHref () {
      const searchParams = {};

      // 如果选择了类型，添加到搜索参数
      if (this.selectedType.id !== 'all-types') {
        searchParams.type = this.selectedType.id;
      }

      // 如果选择了价格区间，添加到搜索参数
      if (this.selectedPrice.id !== 'all-prices') {
        // 根据价格ID设置对应的价格参数
        const priceId = this.selectedPrice.id;
        switch (priceId) {
          case 'less_20000':
            searchParams.mostPrice = 20000;
            break;
          case '20001_40000':
            searchParams.leastPrice = 20001;
            searchParams.mostPrice = 40000;
            break;
          case '40001_60000':
            searchParams.leastPrice = 40001;
            searchParams.mostPrice = 60000;
            break;
          case '60001_80000':
            searchParams.leastPrice = 60001;
            searchParams.mostPrice = 80000;
            break;
          case 'more_80001':
            searchParams.leastPrice = 80001;
            break;
        }
      }

      // 如果选择了品牌，添加到搜索参数
      if (this.selectedBrand.id !== 'all-brands') {
        searchParams.brand = this.selectedBrand.id;
      }

      // 获取当前路由的channel参数和其他自定义查询参数
      const currentQuery = { ...this.$route.query };

      // 合并当前查询参数和搜索参数 (搜索参数优先)
      const finalQuery = { ...currentQuery, ...searchParams };

      const queryString = new URLSearchParams(finalQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        return `/${this.$route.params.channel}/car-list${fullQueryString}`;
      } else {
        return `/car-list${fullQueryString}`;
      }
    }
  },
  methods: {
    // 开始自动轮播
    startAutoplay () {
      this.autoplayTimer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.cars.length;
      }, this.autoplayInterval);
    },

    // 停止自动轮播
    stopAutoplay () {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    // 重启自动轮播（用于用户交互后重新计时）
    restartAutoplay () {
      this.stopAutoplay();
      this.startAutoplay();
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 跳转到车辆详情页面
    gotoDetail (car) {
      if (!car || !car.id) {
        return;
      }
      const currentChannel = this.$router.currentRoute.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const currentQuery = this.$route.query;
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';
      const prefix = currentChannel ? `/${currentChannel}` : '';
      window.location.href = `${prefix}/cars/${formattedName}/${car.id}${fullQueryString}`;
    },

    // ==== 从 CarSearch.vue 复制的功能 ====

    // 处理点击组件外部事件
    handleOutsideClick (event) {
      // 如果点击的不是组件内部元素，则关闭所有下拉菜单
      if (!this.$el.contains(event.target)) {
        this.closeDropdowns();
      }
    },

    // 切换下拉菜单显示状态
    toggleDropdown (type) {
      event.stopPropagation(); // 阻止事件冒泡

      // 切换下拉菜单状态
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }

      console.log('[HomeHero] 当前激活的下拉菜单:', this.activeDropdown);
    },

    // 关闭所有下拉菜单
    closeDropdowns () {
      this.activeDropdown = null;
    },

    // 选择菜单项
    selectItem (type, item) {
      switch (type) {
        case 'type':
          this.selectedType = item;
          break;
        case 'price':
          this.selectedPrice = item;
          break;
        case 'brand':
          this.selectedBrand = item;
          break;
      }

      // 阻止事件冒泡
      event.stopPropagation();

      console.log(`[HomeHero] 已选择 ${type}: `, item.name);

      // 关闭当前下拉菜单
      this.activeDropdown = null;
    }
  }
};
</script>

<style lang="scss">
// 导入公共样式
@import '~@/css/hero.scss';

// 复制并适配 'hero.scss' 中的相关样式
.home-hero__search {
	position: absolute;
	right: 0;
	bottom: 0;
	width: rem(588);
	height: rem(414);
	// background: #ffffff;
	border-radius: rem(36) 0 0 0;
	padding: rem(48) rem(40) rem(48) rem(80);
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
}

.home-hero__title-container {
	display: flex;
	flex-direction: column;
	gap: rem(12);
	align-items: flex-start;
	width: 100%;
}

.home-hero__title-bg {
	background: rgba(20, 20, 20, 0.05);
	border-radius: 0 rem(24) 0 0;
	padding: rem(20) 0 rem(20) rem(20);
	align-self: stretch;
}

.home-hero__title {
	color: #141414;
	font-size: rem(48);
	font-weight: 900;
	line-height: rem(48);
}

.home-hero__title-line {
	width: rem(48);
	height: rem(4);
	background: var(--theme-color);
	border-radius: rem(100);
}

.home-hero__filters {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	width: 100%;
}

.home-hero__filter {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: rem(16) rem(20);
	border: rem(1) solid #e0e0e0;
	border-radius: rem(12);
	cursor: pointer;
	position: relative;
}

.home-hero__filter-content {
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
}

.home-hero__filter-icon {
	width: rem(16);
	height: rem(16);
}

.home-hero__filter-text {
	color: #141414;
	font-size: rem(14);
	font-weight: 400;
	line-height: rem(14);
}

.home-hero__filter-arrow {
	width: rem(16);
	height: rem(16);
	transition: transform 0.3s ease;
	&--rotated {
		transform: rotate(180deg);
	}
}

.home-hero__dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: #ffffff;
	border-radius: rem(8);
	box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
	z-index: 20;
	max-height: rem(300);
	overflow-y: auto;
	margin-top: rem(8);
	&::-webkit-scrollbar {
		display: none;
	}
}

.home-hero__dropdown-inner {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.home-hero__dropdown-item {
	padding: rem(14) rem(20);
	color: #141414;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 400;
	border-bottom: rem(1) solid #f3f3f3;
	cursor: pointer;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background: rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.05);
	}

	&--active {
		color: var(--theme-color);
		font-weight: 500;
	}
}

.home-hero__search-btn {
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: rem(14) rem(40);
	background: var(--theme-color);
	border-radius: rem(12);
	cursor: pointer;
}

.home-hero__search-icon {
	width: rem(20);
	height: rem(20);
}

.home-hero__search-text {
	color: #ffffff;
	font-size: rem(20);
	font-weight: 500;
	line-height: rem(20);
}

// 移动端样式
.home-hero__search-mobile {
	background: linear-gradient(180deg, rgba(254, 132, 0, 0) 0%, rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.3) 100%);
	padding: rem(0) rem(16) rem(52) rem(16);
	display: flex;
	flex-direction: column;
	gap: rem(40);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	position: relative;
}

.home-hero__title-container-mobile {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	width: 100%;
}

.home-hero__title-bg-mobile {
	// background: rgba(20, 20, 20, 0.2);
	border-radius: 0 0 rem(24) 0;
	padding: rem(20) rem(20) rem(20) 0;
	display: flex;
	width: 100%;
}

.home-hero__title-mobile {
	// color: #ffffff;
	color: #141414;
	font-size: rem(48);
	line-height: rem(48);
	font-weight: 900;
	width: 100%;
}

.home-hero__title-line-mobile {
	background: var(--theme-color);
	border-radius: rem(100);
	width: rem(48);
	height: rem(4);
}

.home-hero__filters-mobile {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	width: 100%;
}

.home-hero__filter-mobile {
	background: #ffffff;
	border-radius: rem(12);
	padding: rem(16) rem(20);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	align-self: stretch;
	width: 100%;
	position: relative;
	cursor: pointer;
}

.home-hero__filter-content-mobile {
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
	justify-content: flex-start;
}

.home-hero__filter-icon-mobile {
	width: rem(16);
	height: rem(16);
}

.home-hero__filter-text-mobile {
	color: #141414;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 400;
}

.home-hero__filter-arrow-mobile {
	width: rem(16);
	height: rem(16);
	transition: transform 0.3s ease;
}

.home-hero__dropdown-mobile {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: #ffffff;
	border-radius: rem(8);
	box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
	z-index: 20;
	max-height: rem(200);
	overflow-y: auto;
	margin-top: rem(4);
	&::-webkit-scrollbar {
		display: none;
	}
}

.home-hero__search-btn-mobile {
	background: var(--theme-color);
	border-radius: rem(12);
	padding: rem(14) rem(40);
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
	justify-content: center;
	align-self: stretch;
	width: 100%;
	cursor: pointer;
}

.home-hero__search-icon-mobile {
	width: rem(20);
	height: rem(20);
}

.home-hero__search-text-mobile {
	color: #ffffff;
	font-size: rem(20);
	line-height: rem(20);
	font-weight: 500;
}
</style> 
